module.exports = __webpack_public_path__ + "img/blast-1.0d7cb4c9.jpg";